import type { MessageSchema } from '../../message-bus'
import type { ColorScheme } from './color-scheme'

export enum PublicMessage {
  AppReady = 'AppReady',
  TransferCreated = 'TransferCreated',
  TransferConfirmed = 'TransferConfirmed',
  TransferRejected = 'TransferRejected',
  SessionExpired = 'SessionExpired',
}

export enum InternalMessage {
  AppConfig = 'AppConfig',
}

export interface PublicMessageSchema extends MessageSchema {
  [PublicMessage.AppReady]: undefined
  [PublicMessage.TransferCreated]: {
    referenceId: string
    amount: number
    currency: string
  }
  [PublicMessage.TransferConfirmed]: undefined
  [PublicMessage.TransferRejected]: undefined
}

export interface InternalMessageSchema extends MessageSchema {
  [InternalMessage.AppConfig]: {
    hashToken: string
    colorScheme: ColorScheme
  }
}
